var exports = {
  "r": "GitHubAvatar__XI9GBQ",
  "N": "Link__Ft6ImE",
};

module.exports = exports;
